export const NEWSLETTER_TRANSACTION_KEY = 'newsletter_subscription';
const DEFAULT_NEWSLETTER_REASON = 'Iscrizione alla newsletter';

const toPositiveAmount = (value) => {
  const numericValue = Number(value);
  if (Number.isFinite(numericValue) && numericValue > 0) {
    return numericValue;
  }
  return null;
};

export const resolveNewsletterSignupAlert = ({ result, isSignedIn }) => {
  if (!result?.success) {
    return null;
  }

  const gettonciniFromEnvelope = result?.app_resources?.gettoncini;
  if (isSignedIn && gettonciniFromEnvelope && typeof gettonciniFromEnvelope === 'object') {
    return {
      isAnonymous: false,
      payload: {
        gettoncini: gettonciniFromEnvelope,
      },
    };
  }

  const award = result.gettoncini_award || {};
  const amount = toPositiveAmount(award.amount);
  if (!isSignedIn) return { isAnonymous: true, payload: result };
  const message =
    (typeof award.message === 'string' && award.message) ||
    award.description ||
    DEFAULT_NEWSLETTER_REASON;

  if (award.awarded && isSignedIn && amount) {
    return {
      isAnonymous: false,
      payload: {
        gettoncini: {
          balance: typeof award.new_balance === 'number' ? award.new_balance : null,
          transactions: [
            {
              type: 'game_completion',
              amount,
              description: award.description || DEFAULT_NEWSLETTER_REASON,
              message,
              key: award.transaction_key || NEWSLETTER_TRANSACTION_KEY,
            },
          ],
        },
      },
    };
  }

  return null;
};
